<template>
    <v-tab-item :value="Analyzer.value">
        <v-container>
            <top-image :tit="Analyzer.text" bgImage="/images/sub/product/analyzer-bg.jpg" image="/images/sub/product/analyzer-img.png">
                <p class="page-text mb-6 mb-lg-20">
                    케이아이이 시스템즈는 석유 및 가스, 석유화학, 광업, 발전소 등 다양한 산업군을 대상으로 분석기 패키지 시스템의 설계, 제조 및 시운전을 전문으로 합니다.
                </p>
                <p class="page-text mb-6 mb-lg-20">
                    GC (Gas Chromatography) 분석기, IR (Infrared Spectroscopy) 분석기, NIR (Near-Infrared Spectroscopy) 분석기, Total Sulfur Analyzer 및 물리적 특성을 이용한 분석기 등 다양한 분석기와 이를 수용할 수 있는 쉘터, 캐비닛 및 랙 등을 포함한 분석기 패키지 시스템을 제공합니다. 고객에게 최상의 품질과 성능을 보장하기 위해 신뢰성 높은 제조업체에서 분석기를 신중하게 선택합니다.
                </p>
                <p class="page-text mb-6 mb-lg-20">
                    분석기 시스템은 고객의 요구사항에 따라 맞춤형으로 제작되며, 원활하고 안전한 분석을 위해 필수적으로 샘플링 시스템, 쉘터 내부 온도 및 습도를 조절하기 위한 HVAC (Heating, Ventilation and Air Conditioning), 장비의 안전 운영을 보장하기 위한 안전 시스템도 함께 제공됩니다.
                </p>
                <p class="page-text mb-6 mb-lg-20">
                    케이아이이 시스템즈는 경험이 풍부한 엔지니어들이 고객과 긴밀히 협력하여 최상의 품질과 성능을 보장합니다.
                </p>
                <p class="page-text">
                    또한 전문 기술 지원 및 유지보수 서비스를 제공하여 시스템이 항상 최상의 성능으로 작동하도록 지원합니다. 케이아이이 시스템즈는 고객의 특별한 요구사항을 이해하고, 그에 맞는 맞춤형 솔루션을 제공하여 원활하고 안전한 분석을 보장합니다.
                </p>
            </top-image>
        </v-container>
    </v-tab-item>
</template>

<script>
import TopImage from "@/components/dumb/top-image.vue";
import { Ko_Product_TABS } from "@/assets/variables";
const { Analyzer } = Ko_Product_TABS;
export default {
    components: {
        TopImage,
    },
    data() {
        return {
            Analyzer,
        };
    },
};
</script>

<style scoped></style>
